<template>
  <aside class="db-sidebar" :class="{ 'is-collapsed': collapsed, 'is-open': open }" aria-label="Menú del panel">
    <div class="db-sidebar-brand">
      <img
        v-if="!collapsed"
        :src="$store.getters.isDarkMode ? require('@/assets/img/logo_santo_domingo_dark.png') : require('@/assets/img/logo_santo_domingo.png')"
        :alt="$root.constantes.logo_nombre_sitio"
      />
      <button
        type="button"
        class="db-icon-btn db-only-desktop"
        :aria-label="collapsed ? 'Expandir menú' : 'Contraer menú'"
        :title="collapsed ? 'Expandir menú' : 'Contraer menú'"
        @click="$emit('toggle')"
      >
        <span class="material-symbols-outlined">{{ collapsed ? "left_panel_open" : "left_panel_close" }}</span>
      </button>
      <button type="button" class="db-icon-btn db-only-mobile" aria-label="Cerrar menú" @click="$emit('close')">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <nav class="db-sidebar-nav">
      <template v-for="grupo in grupos">
        <p v-if="grupo.items.length" :key="'t-' + grupo.titulo" class="db-sidebar-section">{{ grupo.titulo }}</p>
        <button
          v-for="item in grupo.items"
          :key="item.key"
          type="button"
          class="db-nav-item"
          :class="{ 'is-active': active === item.key }"
          :title="collapsed ? item.text : null"
          :aria-current="active === item.key ? 'page' : null"
          @click="$emit('pag', item.key)"
        >
          <span class="material-symbols-outlined">{{ item.icon }}</span>
          <span class="db-nav-label">{{ item.text }}</span>
        </button>
      </template>
    </nav>

    <div class="db-sidebar-footer">
      <button
        type="button"
        class="db-nav-item db-nav-item--danger"
        :title="collapsed ? 'Cerrar sesión' : null"
        @click="cerrarSesion"
      >
        <span class="material-symbols-outlined">logout</span>
        <span class="db-nav-label">Cerrar sesión</span>
      </button>
    </div>
  </aside>
</template>

<script>
import axios from "@/directives/axios.js";
import { confirmar } from "@/directives/dbDialogs.js";
import { seccionesPermitidas } from "./secciones.js";

export default {
  name: "SidebarComp",

  props: {
    active: { type: String, default: "principal" },
    collapsed: { type: Boolean, default: false },
    open: { type: Boolean, default: false },
  },

  computed: {
    grupos() {
      const grupos = [];
      seccionesPermitidas(this.$store.getters.puede).forEach((s) => {
        let grupo = grupos.find((g) => g.titulo === s.grupo);
        if (!grupo) grupos.push((grupo = { titulo: s.grupo, items: [] }));
        grupo.items.push({ key: s.key, text: s.texto, icon: s.icon });
      });
      return grupos;
    },
  },

  methods: {
    async cerrarSesion() {
      const ok = await confirmar(this, "¿Quieres cerrar la sesión?", { titulo: "Cerrar sesión", ok: "Cerrar sesión" });
      if (!ok) return;
      try {
        await axios.post("/logout");
      } catch (error) {
        // Aunque el token ya haya caducado, se limpia la sesión local.
      } finally {
        sessionStorage.removeItem("token_parmada");
        this.$store.commit("setUsuario", null);
        this.$router.replace({ name: "login" });
      }
    },
  },
};
</script>
